var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconNewTab = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#2D2D2D",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "m0 6 2-2v14l-2-2h14l-2 2V4l2 2zm14-2v14H0V4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 0h2v6H4zM16 0h2v14h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 0v2H4V0zM18 12v2h-4v-2z"
}))));
export default SvgIconNewTab;